// Api/Config/PostConfig.js
import axios from 'axios';
import { getAuthToken } from '../../Storage/Getter';
import { loaderInstance } from '../../Components/LoaderSingleton';

export default async function post(url, obj, loader=true) {
  const token = getAuthToken();
  const defaultOptions = {
    headers: {
      'Authorization': token ? `Bearer ${token}` : '',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'x-content-type-options': 'nosniff',
      'Referrer-Policy': 'no-referrer'
    },
  };

  // Remove content-type for FormData (auto-set by browser)
  if (obj instanceof FormData) {
    delete defaultOptions.headers['Content-Type'];
  }

  try {
    if(loader)
      loaderInstance.set(true); // Start global loader
    const response = await axios.post(url, obj, defaultOptions);
    return response.data;
  } catch (error) {
      // Network error: no response from server
        if (error.code === "ERR_NETWORK" || !error.response) {
            alert("Network error: Please check your internet connection or try again later.");
            return { status: 0, message: "Network error" };
        }
        // API responded with error
        const response = error.response?.data || {};
            if (error.response?.status === 401) {
            alert("Session expired. Please log in again.");
        }
        return response;
  } finally {
    if(loader)
      loaderInstance.set(false); // Stop loader
  }
}
